import dayjs from "dayjs";
import React, { useState } from "react";

const ReceiptPrinter = ({tripDetails}) => {
 
    
    // const convertToIST = (utcDate) => {

    //     if (!utcDate) {
    //       return ""
    //     }

    //       return new Date(new Date(utcDate).getTime() + time_zone * 60 * 1000)
    //         .toLocaleString("en-GB", { 
    //           day: "2-digit", 
    //           month: "short", 
    //           year: "numeric", 
    //           hour: "2-digit", 
    //           minute: "2-digit", 
    //           second: "2-digit",  // You can remove this if you don't want seconds
    //           hour12: false,
    //           timeZoneName: undefined  // This removes the timezone (GMT)
    //         });
    //     };
        

  const printReceipt = async () => {
    try {
      // Ensure imin-printer is loaded
      if (!window.IminPrinter) {
        throw new Error("IminPrinter is not available. Ensure the script is loaded.");
      }

      const IminPrintInstance = new window.IminPrinter();
      const isConnected = await IminPrintInstance.connect();

      if (!isConnected) {
        throw new Error("Printer connection failed.");
      }

          IminPrintInstance.initPrinter();
          IminPrintInstance.setAlignment(1);
          IminPrintInstance.setTextSize(18);
          IminPrintInstance.printColumnsText(["RECEIPT"], [1], [1], [26], 576);
          IminPrintInstance.setTextSize(18);
          IminPrintInstance.setAlignment(1);

          IminPrintInstance.printColumnsText(["OTP"], [1], [1], [18], 576);
          IminPrintInstance.printColumnsText([tripDetails.otp], [1], [1], [50], 576);

          IminPrintInstance.printQrCode(tripDetails.otp, 1);
          IminPrintInstance.setAlignment(1);
          IminPrintInstance.setAlignment(1);

          IminPrintInstance.printColumnsText(["Vehicle Type",tripDetails.cat_name], [1,1], [0,2], [26], 576);
  
          IminPrintInstance.printColumnsText(["Please share the OTP or scan the QR Code with the Driver to start the trip."], [1], [1], [18], 576);
          IminPrintInstance.printColumnsText(["-------------------------------"],[1],[1],[42],576)

          IminPrintInstance.printColumnsText(["Trip Details"], [1], [0], [18], 576)
          IminPrintInstance.setAlignment(0);
          IminPrintInstance.printColumnsText(
           [
          "Date",
          dayjs.utc(tripDetails.trip_date)
            .tz("Asia/Kolkata")
            .format("YYYY-MM-DD HH:mm")
           ],
           [1, 1], 
           [0, 2], 
           [18, 18], 
           576
           );      
          IminPrintInstance.printColumnsText(["From", `${tripDetails.trip_from_loc}`], [1,1],[0,2],[18,18],576)
          IminPrintInstance.printColumnsText(["To", `${tripDetails.trip_to_loc}`], [1,1],[0,2],[18,18],576)
          IminPrintInstance.printColumnsText(["Estimated Fare", `${`${tripDetails.trip_currency} ${tripDetails.trip_pay_amount}`}`], [1,1],[0,2],[18,18],576)
          IminPrintInstance.printColumnsText(["-------------------------------"],[1],[1],[42],576)
          IminPrintInstance.setAlignment(1)

          IminPrintInstance.printColumnsText(["Happy Journey… Thank you for using our service!"], [1],[0],[18],576)
          IminPrintInstance.printColumnsText(["*Kindly note that the OTP will expire in 120 minutes"], [1],[0],[18],576)
          IminPrintInstance.printColumnsText(["**You are not obliged for payment if no trip is availed"], [1],[0],[18],576)
          IminPrintInstance.printColumnsText(["***Fare may vary if Vehicle Type is changed"], [1],[0],[18],576)
          IminPrintInstance.printColumnsText(["-------------------------------"],[1],[1],[42],576)
          IminPrintInstance.printColumnsText(["Powered by HireMe"], [1],[1],[18],576)
          IminPrintInstance.setAlignment(1);
          IminPrintInstance.printText("\n\n");

    //   alert("Receipt printed successfully!");
    } catch (error) {
      console.error("Error printing receipt:", error);
      alert("Failed to print receipt: " + error.message);
    }
  };

  return (
      <div>
      <button className="book-btn" onClick={printReceipt}>
       Print Receipt / طباعة الإيصال
      </button>
      </div>
  );
};

export default ReceiptPrinter;
